import { schema } from "normalizr";
import FilterRecord from "records/filter";

const FilterSchema = new schema.Entity(
    "filters",
    {},
    {
        idAttribute: "__key", // set id on server maybe?
    },
);

FilterSchema.record = FilterRecord;

export default FilterSchema;
